module.exports = __webpack_public_path__ + "4ce1887ff6c27d73fd80b2b877268899.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/checkout/en/instapay.png
// module id = ./app/images/checkout/en/instapay.png
// module chunks = 40